<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
		[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container security-page-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>My Plan <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Security'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Security</h1>
			</div>
		</section>
		<section class="security-data-content">
			<h3 class="title">Security & Data Protection</h3>
			<p>
				Looking after your important information is something we take extremely seriously, which is why we are
				commited to protecting all the personal data that we handle with gold standard security and data
				protection policies.
			</p>
			<section class="sponsors-container">
				<div class="sponsor">
					<img src="../../assets/img/{{themeService.theme}}/ICO.jpg" alt="" height="90px">
					<p>Registered with the Information Commissioner's Office</p>
				</div>
				<div class="sponsor">
					<img src="../../assets/img/{{themeService.theme}}/cyberessentials-certification.png" alt=""
						height="90px">
					<p>Certified by the government's Cyber Essentials scheme</p>
				</div>
				<div class="sponsor">
					<img src="../../assets/img/{{themeService.theme}}/ISO.png" alt="" height="90px">
					<p>All data securely stored in a IS27001 certified data centre</p>
				</div>
			</section>
			<section class="explanations-security-container">
				<article class="block">
					<img src="../../assets/img/{{themeService.theme}}/encrypt-data-rest.svg" alt="" width="90px">
					<div class="encrypted-data-storage">
						<h5 class="section-title">Encrypted data storage</h5>
						<p>All your data is stored on 256 bit encrypted servers - this means it's never stored in the
							open for third parties
							to access. Our secure servers are based in the UK and meet ISO27001 certification, the best
							practice framework for information security management, which ensures your data is kept safe
							and backed up all times.
						</p>
					</div>
				</article>
				<article class="block encrypted-data-communication-container">
					<img src="../../assets/img/{{themeService.theme}}/encrypt-data-transit.svg" alt="" width="110px"
						height="100px">
					<div class="encrypted-data-communication">
						<h5 class="section-title">Encrypted data communication</h5>
						<p *ngIf="activeTheme.name == 'defaultTheme'">
							When using Zenplans, the transmission of
							information is protected using TLS 1.2 with 256 bit
							key encryption
							- this means no one can read your data on route between your device and our secure
							servers.
							Our servers are only accessible via an encryption key, which protects all user
							authentication and commands against potential attacks to our network.
						</p>
						<p *ngIf="activeTheme.name != 'defaultTheme'">The transmission of information is
							protected using TLS 1.2 with 256 bit
							key encryption
							- this means no one can read your data on route between your device and our secure
							servers.
							Our servers are only accessible via an encryption key, which protects all user
							authentication and commands against potential attacks to our network.
						</p>

					</div>
				</article>
				<article class="block">
					<img src="../../assets/img/{{themeService.theme}}/multi-factor-authentication.svg" alt=""
						width="90px">
					<div class="account-security">
						<h5 class="section-title">Account Security</h5>
						<p *ngIf="activeTheme.name == 'defaultTheme'">
							The information that you choose to store in your plan can only be accessed by you and your
							appointed delegates - <strong>the Zenplans team can never see the information stored in your
								plan.</strong> Industry leading measures to prevent unauthorised access to
							your account, such as multifactor authentication, strong password requirements and automatic
							session time outs.
						</p>
						<p *ngIf="activeTheme.name != 'defaultTheme'">
							The information that you choose to store in your plan can only be accessed by you and your
							appointed delegates - <strong>We can never see the information stored in your
								plan.</strong> Industry leading measures to prevent unauthorised access to
							your account, such as multifactor authentication, strong password requirements and automatic
							session time outs.
						</p>
					</div>
				</article>
				<article class="block">
					<img src="../../assets/img/{{themeService.theme}}/operational-process-security.svg" alt=""
						width="90px">
					<div class="platform-security">
						<h5 class="section-title">Platform and organisational security</h5>
						<p *ngIf="activeTheme.name == 'defaultTheme'">
							Zenplans uses engineering best practices and regular audits to protect the platform from
							external security threats. As an organisation, Zenplans has invested heavily in developing
							gold standard policies and
							procedures to responsibly handle data effectively manage risk, ensuring a rapid response to
							issues, should they emerge.
						</p>
						<p *ngIf="activeTheme.name != 'defaultTheme'">
							We use engineering best practices and regular audits to protect the platform from
							external security threats. As an organisation, we have invested heavily in developing
							gold standard policies and
							procedures to responsibly handle data effectively manage risk, ensuring a rapid response to
							issues, should they emerge.
						</p>
					</div>
				</article>
			</section>
		</section>
	</section>
</section>

<app-scroll-top></app-scroll-top>